import React, { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  button: {
    padding: 0,
    border: 'none',
    background: 'none',
    '&:hover': {
      cursor: 'pointer',
      color: '#00A1A1',
    },
    '&:focus': {
      color: '#00A1A1',
    },
  },
  menuItems: {
    '&> *': {
      padding: '6px 16px',
      fontSize: '14px',
      color: 'rgba(0,0,0,0.87)',
    },
  },
};
const ListItemActionsMenu = ({ classes, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <button
        className={classes.button}
        aria-owns={anchorEl ? 'simple-menu' : null}
        aria-haspopup="true"
        onClick={handleClick}>
        <MoreHorizIcon/>
      </button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <div onClick={handleClose} className={classes.menuItems}>
          {children}
        </div>
      </Menu>
    </div>
  );

};

export default withStyles(styles)(ListItemActionsMenu);
